import store from "../../store";
import * as ACTIONS from "./action";

const obj = {
  // Sessiion managmement
  getAllActiveSession: () => store.dispatch(ACTIONS.getAllActiveSession()),
  getAllCompleteSession:()=>store.dispatch(ACTIONS.getAllCompleteSession()),
  CompleteSession:(id,data)=>store.dispatch(ACTIONS.CompleteSession(id,data)),
  viewSession: (id) => store.dispatch(ACTIONS.viewSession(id)),
  updateSession: (data, id) => store.dispatch(ACTIONS.updateSession(data, id)), //
  deleteSession: (id) => store.dispatch(ACTIONS.deleteSession(id)),
  createSession: (data) => store.dispatch(ACTIONS.createSession(data)),
  lunchSession:(id,data)=>store.dispatch(ACTIONS.lunchSession(id,data)),
  //end

  // Profile Update (users and admin)
  // updateAdminProfile: (data) => store.dispatch(ACTIONS.updateAdminProfile(data)),
  getUserProfile: () => store.dispatch(ACTIONS.getUserProfile()),
  resetPassword: (data) => store.dispatch(ACTIONS.resetPassword(data)),
  changePassword:(data) => store.dispatch(ACTIONS.changePassword(data)), 
  //End
  
  //user Mangament
  getAllUsers:()=>store.dispatch(ACTIONS.getAllUsers()), //   
  createUser:(data)=>store.dispatch(ACTIONS.createUser(data)), //   Create User 
  userUpdate:(data,id) =>store.dispatch(ACTIONS.userUpdate(data,id)), // update User 
  getOneUser:(id) =>store.dispatch(ACTIONS.getOneUser(id)),
  deleteUser:(id)=>store.dispatch(ACTIONS.deleteUser(id)),
  //End


  //Sop Generation
  createSop:(id)=>store.dispatch(ACTIONS.createSop(id)),
  downloadSop:()=>store.dispatch(ACTIONS.downloadSop()),
  viewSop:(id)=>store.dispatch(ACTIONS.viewSop(id)),
  editSop:(data)=>store.dispatch(ACTIONS.editSop(data)),
  micData:(data,id)=>store.dispatch(ACTIONS.micData(data,id)),
  createFaq:(data)=>store.dispatch(ACTIONS.createFaq(data)),
  getAllFaq:()=>store.dispatch(ACTIONS.getAllFaq()),
  deleteFaq:(id)=>store.dispatch(ACTIONS.deleteFaq(id)),

  questionData:(data)=>store.dispatch(ACTIONS.questionData(data)),
  updatesRelevant:(data)=>store.dispatch(ACTIONS.updatesRelevant(data)),
  getQuestionList:(data)=>store.dispatch(ACTIONS.getQuestionList(data)),
  allMarkedQuestion:(data)=>store.dispatch(ACTIONS.allMarkedQuestion(data)),

  // sessionAlreadyLunched:(data)=>store.dispatch(ACTIONS.sessionAlreadyLunched(data)),
  // getContactDetails:()=>store.dispatch(ACTIONS.getContactDetails()),

  //Video mangnment
  createVideoSession:(data) =>store.dispatch(ACTIONS.createVideoSession(data)),
  deleteVideoSession:(id)=>store.dispatch(ACTIONS.deleteVideoSession(id)),
  getAllVideoSession:() =>store.dispatch(ACTIONS.getAllVideoSession()),
  generateImageScript:(videoSessionId, data)=>store.dispatch(ACTIONS.generateImageScript(videoSessionId, data)),
  fetchListImageScript:(videoSessionId)=>store.dispatch(ACTIONS.fetchListImageScript(videoSessionId)),
  uploadImageReplacement:(videoSessionId,itemId,cardId,formData)=>store.dispatch(ACTIONS.uploadImageReplacement(videoSessionId,itemId,cardId,formData)),
  deleteImageScript:(cardId)=>store.dispatch(ACTIONS.deleteImageScript(cardId)),
  updateScript:(itemId, data)=> store.dispatch(ACTIONS.updateScript(itemId, data)),
  createVideoInput:(cardId) =>store.dispatch(ACTIONS.createVideoInput(cardId)),
  deleteVideoInput: (cardId, videoSessionId) =>store.dispatch(ACTIONS.deleteVideoInput(cardId,videoSessionId)),
  getOneVideocard: (videoSessionId,cardId)=>store.dispatch(ACTIONS.getOneVideocard(videoSessionId,cardId)),

  //merge
  createMerge:(data)=>store.dispatch(ACTIONS.createMerge(data)),
  uploadVideo:(formData ,videoSessionId)=> store.dispatch(ACTIONS.uploadVideo(formData ,videoSessionId)),
  getAllMergeVideo:(videoSessionId) =>store.dispatch(ACTIONS.getAllMergeVideo(videoSessionId)),
  deleteMergeVideo:(id)=>store.dispatch(ACTIONS.deleteMergeVideo(id)),
  MergeAllVideo:(data)=>store.dispatch(ACTIONS.MergeAllVideo(data)),
  MergeVideolist: (mergeVideoRequestId)=>store.dispatch(ACTIONS.MergeVideolist(mergeVideoRequestId)),
  createStepAndHeading:(data)=>store.dispatch(ACTIONS.createStepAndHeading(data)),
  //Key / Value management 
  getAllKeyVAlue:()=>store.dispatch(ACTIONS.getAllKeyVAlue()),
  updateKeyValue:(item,data)=>store.dispatch(ACTIONS.updateKeyValue(item ,data)),
  deleteKeyValue:(id)=>store.dispatch(ACTIONS.deleteKeyValue(id)),
  createKeyValue:(data)=>store.dispatch(ACTIONS.createKeyValue(data)),
  getDuration:(id)=>store.dispatch(ACTIONS.getDuration(id)),
  videoEnhancement:(data)=>store.dispatch(ACTIONS.videoEnhancement(data)),
  deleteMergeList:(id) =>store.dispatch(ACTIONS.deleteMergeList(id)),
  generateVideo:(id) =>store.dispatch(ACTIONS.generateVideo(id)),
  regenerateVideo:(id,videoSessionId)=>store.dispatch(ACTIONS.regenerateVideo(id,videoSessionId)),
  rearrangeVideo:(data)=>store.dispatch(ACTIONS.rearrangeVideo(data)),
  
};
export default obj;
